module.exports = __webpack_public_path__ + "static/media/md-sad.a457c526.svg";